import {
  Avatar,
  Box,
  Button,
  Card,
  CardBody,
  CardHeader,
  Checkbox,
  Flex,
  FormControl,
  FormLabel,
  Icon,
  Image,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
  useToast,
  Container,
  ListItem,
  Heading,
  List,
  Link
} from "@chakra-ui/react";
import { useEffect, useRef, useState } from "react";

const TermsModal = ({ isOpen, onClose }) => {
  return (
    <div>
      <Modal
        size="6xl"
        isOpen={isOpen}
        onClose={onClose}
        motionPreset="slideInBottom"
      >
        <ModalOverlay
          bg="rgba(0, 0, 0, 0.8)"
          backdropFilter="hue-rotate(10deg)"
        />
        <ModalContent bg="#B9314F" transition="0.5s linear">
          <ModalHeader>
            <Text
              align="top"
              fontSize={{ sm: "lg", lg: "xl" }}
              // color="textLightTheme.1"
              fontWeight="bold"
              ms={{ sm: "8px", md: "0px" }}
              ml="20px"
              color="whiteAlpha.900"
            >
              Terms and Conditions
            </Text>
          </ModalHeader>
          <ModalCloseButton size='lg' color="rgba(255, 255, 255, 0.8)" />
          <ModalBody bgColor="#E1DEE3">
            <Container maxW={"7xl"} color="#1A1423" fontSize={{ xl: "md", lg: "md", md: "md", sm: "sm", base: "sm" }}>
              <Heading as="h3" size="md" mt={6}>Welcome to Amestair!</Heading>

              <Text mt={4}>
                These terms and conditions outline the rules and regulations for the use
                of Amestair's Website, located at www.amestair.com
              </Text>

              <Text mt={4}>
                By accessing this website we assume you accept these terms and
                conditions. Do not continue to use Amestair if you do not agree to take
                all of the terms and conditions stated on this page.
              </Text>

              <Text mt={4}>
                The following terminology applies to these Terms and Conditions, Privacy
                Statement and Disclaimer Notice and all Agreements: "Client", "You" and
                "Your" refers to you, the person log on this website and compliant to
                the Company’s terms and conditions. "The Company", "Ourselves", "We",
                "Our" and "Us", refers to our Company. "Party", "Parties", or "Us",
                refers to both the Client and ourselves. All terms refer to the offer,
                acceptance and consideration of payment necessary to undertake the
                process of our assistance to the Client in the most appropriate manner
                for the express purpose of meeting the Client’s needs in respect of
                provision of the Company’s stated services, in accordance with and
                subject to, prevailing law of Netherlands. Any use of the above
                terminology or other words in the singular, plural, capitalization
                and/or he/she or they, are taken as interchangeable and therefore as
                referring to same.
              </Text>

              <Heading as="h3" size="md" mt={6}>
                Cookies
              </Heading>

              <Text mt={4}>
                We employ the use of cookies. By accessing Amestair, you agreed to use
                cookies in agreement with Amestair's Privacy Policy.
              </Text>

              <Text mt={4}>
                Most interactive websites use cookies to let us retrieve the user’s
                details for each visit. Cookies are used by our website to enable the
                functionality of certain areas to make it easier for people visiting our
                website. Some of our affiliate/advertising partners may also use
                cookies.
              </Text>

              <Heading as="h3" size="md" mt={6}>
                License
              </Heading>

              <Text mt={4}>
                Unless otherwise stated, Amestair and/or its licensors own the
                intellectual property rights for all material on Amestair. All
                intellectual property rights are reserved. You may access this from
                Amestair for your own personal use subjected to restrictions set in
                these terms and conditions.
              </Text>

              <Text mt={4}>You must not:</Text>
              <List spacing={2} mt={2}>
                <ListItem>Republish material from Amestair</ListItem>
                <ListItem>Sell, rent or sub-license material from Amestair</ListItem>
                <ListItem>Reproduce, duplicate or copy material from Amestair</ListItem>
                <ListItem>Redistribute content from Amestair</ListItem>
              </List>

              <Text mt={4}>
                Parts of this website offer an opportunity for users to post and exchange
                opinions and information in certain areas of the website. Amestair does
                not filter, edit, publish or review Comments prior to their presence on
                the website. Comments do not reflect the views and opinions of Amestair,
                its agents and/or affiliates. Comments reflect the views and opinions of
                the person who post their views and opinions. To the extent permitted by
                applicable laws, Amestair shall not be liable for the Comments or for
                any liability, damages or expenses caused and/or suffered as a result of
                any use of and/or posting of and/or appearance of the Comments on this
                website.
              </Text>

              <Text mt={4}>
                Amestair reserves the right to monitor all Comments and to remove any
                Comments which can be considered inappropriate, offensive or causes
                breach of these Terms and Conditions.
              </Text>

              <Text mt={4}>You warrant and represent that:</Text>

              <List spacing={2} mt={2}>
                <ListItem>
                  You are entitled to post the Comments on our website and have all
                  necessary licenses and consents to do so;
                </ListItem>
                <ListItem>
                  The Comments do not invade any intellectual property right, including
                  without limitation copyright, patent or trademark of any third party;
                </ListItem>
                <ListItem>
                  The Comments do not contain any defamatory, libelous, offensive,
                  indecent or otherwise unlawful material which is an invasion of
                  privacy;
                </ListItem>
                <ListItem>
                  The Comments will not be used to solicit or promote business or custom
                  or present commercial activities or unlawful activity.
                </ListItem>
              </List>

              <Text mt={4}>
                You hereby grant Amestair a non-exclusive license to use, reproduce, edit
                and authorize others to use, reproduce and edit any of your Comments in
                any and all forms, formats or media.
              </Text>

              <Heading as="h3" size="md" mt={6}>
                Hyperlinking to our Content
              </Heading>

              <Text mt={4}>
                The following organizations may link to our Website without prior
                written approval:
              </Text>

              <List spacing={2} mt={2}>
                <ListItem>Government agencies;</ListItem>
                <ListItem>Search engines;</ListItem>
                <ListItem>News organizations;</ListItem>
                <ListItem>
                  Online directory distributors may link to our Website in the same
                  manner as they hyperlink to the Websites of other listed businesses;
                </ListItem>
                <ListItem>
                  System wide Accredited Businesses except soliciting non-profit
                  organizations, charity shopping malls, and charity fundraising groups
                  which may not hyperlink to our Web site.
                </ListItem>
              </List>

              <Text mt={4}>
                These organizations may link to our home page, to publications or to
                other Website information so long as the link: (a) is not in any way
                deceptive; (b) does not falsely imply sponsorship, endorsement or
                approval of the linking party and its products and/or services; and (c)
                fits within the context of the linking party’s site.
              </Text>

              <Text mt={4}>
                We may consider and approve other link requests from the following types
                of organizations:
              </Text>

              <List spacing={2} mt={2}>
                <ListItem>commonly-known consumer and/or business information sources;</ListItem>
                <ListItem>dot.com community sites;</ListItem>
                <ListItem>associations or other groups representing charities;</ListItem>
                <ListItem>online directory distributors;</ListItem>
                <ListItem>internet portals;</ListItem>
                <ListItem>accounting, law and consulting firms;</ListItem>
                <ListItem>educational institutions and trade associations.</ListItem>
              </List>

              <Text mt={4}>
                We will approve link requests from these organizations if we decide that:
                (a) the link would not make us look unfavorably to ourselves or to our
                accredited businesses; (b) the organization does not have any negative
                records with us; (c) the benefit to us from the visibility of the
                hyperlink compensates the absence of Amestair; and (d) the link is in
                the context of general resource information.
              </Text>

              <Text mt={4}>
                Approved organizations may hyperlink to our Website as follows:
              </Text>

              <List spacing={2} mt={2}>
                <ListItem>By use of our corporate name;</ListItem>
                <ListItem>By use of the uniform resource locator being linked to;</ListItem>
                <ListItem>
                  By use of any other description of our Website being linked to that
                  makes sense within the context and format of content on the linking
                  party’s site.
                </ListItem>
              </List>

              <Text mt={4}>
                No use of Amestair's logo or other artwork will be allowed for linking
                absent a trademark license agreement.
              </Text>

              <Heading as="h3" size="md" mt={6}>
                iFrames
              </Heading>

              <Text mt={4}>
                Without prior approval and written permission, you may not create frames
                around our Webpages that alter in any way the visual presentation or
                appearance of our Website.
              </Text>

              <Heading as="h3" size="md" mt={6}>
                Content Liability
              </Heading>

              <Text mt={4}>
                We shall not be held responsible for any content that appears on your
                Website. You agree to protect and defend us against all claims that is
                rising on your Website. No link(s) should appear on any Website that may
                be interpreted as libelous, obscene or criminal, or which infringes,
                otherwise violates, or advocates the infringement or other violation of,
                any third party rights.
              </Text>

              <Heading as="h3" size="md" mt={6}>
                Your Privacy
              </Heading>

              <Text mt={4}>Please read our Privacy Policy</Text>

              <Heading as="h3" size="md" mt={6}>
                Reservation of Rights
              </Heading>

              <Text mt={4}>
                We reserve the right to request that you remove all links or any
                particular link to our Website. You approve to immediately remove all
                links to our Website upon request. We also reserve the right to amend
                these terms and conditions and its linking policy at any time. By
                continuously linking to our Website, you agree to be bound to and follow
                these linking terms and conditions.
              </Text>

              <Heading as="h3" size="md" mt={6}>
                Removal of links from our website
              </Heading>

              <Text mt={4}>
                If you find any link on our Website that is offensive for any reason,
                you are free to contact and inform us at any moment. We will consider
                requests to remove links but we are not obligated to or so or to respond
                to you directly.
              </Text>

              <Text mt={4}>
                We do not ensure that the information on this website is correct, we do
                not warrant its completeness or accuracy; nor do we promise to ensure
                that the website remains available or that the material on the website
                is kept up to date.
              </Text>

              <Heading as="h3" size="md" mt={6}>
                Disclaimer
              </Heading>

              <Text mt={4}>
                To the maximum extent permitted by applicable law, we exclude all
                representations, warranties and conditions relating to our website and
                the use of this website. Nothing in this disclaimer will:
              </Text>

              <List spacing={2} mt={2}>
                <ListItem>limit or exclude our or your liability for death or personal injury;</ListItem>
                <ListItem>
                  limit or exclude our or your liability for fraud or fraudulent
                  misrepresentation;
                </ListItem>
                <ListItem>
                  limit any of our or your liabilities in any way that is not permitted
                  under applicable law; or
                </ListItem>
                <ListItem>
                  exclude any of our or your liabilities that may not be excluded under
                  applicable law.
                </ListItem>
              </List>

              <Text mt={4}>
                The limitations and prohibitions of liability set in this Section and
                elsewhere in this disclaimer: (a) are subject to the preceding
                paragraph; and (b) govern all liabilities arising under the disclaimer,
                including liabilities arising in contract, in tort and for breach of
                statutory duty.
              </Text>

              <Text mt={4}>
                As long as the website and the information and services on the website
                are provided free of charge, we will not be liable for any loss or
                damage of any nature.
              </Text>
            </Container>
          </ModalBody>
          <ModalFooter bgColor="#E1DEE3" pt={{ base: "15px", sm: "15px", md: "20px", lg: "20px" }} justifyContent="center">
            <Button
              // variant="solid"
              bg={'"#E1DEE3"'}
              // boxShadow={
              //   '0px 1px 25px -5px rgb(66 153 225 / 8%), 0 10px 10px -5px rgb(66 153 225 / 8%)'
              // }
              size={{ xl: "md", lg: "md", md: "md", sm: "sm", base: "sm" }}
              _hover={{
                bg: '#B9314F',
                color: "white"
              }}
              border="1px solid #B9314F"
              color="#1A1423"
              // width="50%"
              onClick={() => onClose()}
            >
              Close Terms and Conditions
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </div>
  );
};

export default TermsModal;
